import React from "react";
import { AiOutlineGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { SiUpwork } from "react-icons/si";
import { Slide } from "react-awesome-reveal";
import { Container, Texts, Social, Profile } from "./ProfComponentStyles";

const ProfComponent = () => {
  return (
    <Container id="home">
      <Slide direction="left">
        <Profile>
          <img
            loading="lazy"
            height="380"
            src="https://res.cloudinary.com/dswxpp4qr/image/upload/muhammadfaizan_g77fpq.webp"
            alt="Muhammad Faizan"
          />
        </Profile>
      </Slide>
      <Slide direction="right">
        <Texts>
          <h4>
            Hello <span className="green">I'am</span>
          </h4>
          <h1 className="green">Muhammad Faizan</h1>
          <h3>Professional Full Stack Developer</h3>
          <p>
            From designing and developing user interfaces to server-side
            infrastructure and database management, I am well-versed in every
            aspect of web development.
          </p>
          <a
            style={{
              marginTop: "2rem",
              textDecoration: "none",
              color: "white",
              display: "inline-block",
              padding: "10px 20px",
              backgroundColor: "#01be96",
              borderRadius: "5px",
              cursor: "pointer",
              filter: "drop-shadow(0px 10px 10px #01be9551)",
            }}
            href="https://muhfaizan.com/Muhammad_Faizan.pdf"
            download="Muhammad_Faizan"
          >
            Download Resume
          </a>
          <Social>
            <p className="check-out-my">Check out my</p>
            <div className="social-icons">
              <span>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://github.com/faizan-2022"
                >
                  <AiOutlineGithub />
                </a>
              </span>
              <span>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.linkedin.com/in/muhammad-faizan-341186237/"
                >
                  <FaLinkedinIn />
                </a>
              </span>
              <span>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.upwork.com/freelancers/~01524beaf8588b6588?mp_source=share"
                >
                  <SiUpwork />
                </a>
              </span>
            </div>
          </Social>
        </Texts>
      </Slide>
    </Container>
  );
};

export default ProfComponent;